export class DemographicOptionsViewModel {
    public firstName: string;
    public lastName: string;
    public organizationName: string;
    public collectTitle: boolean;
    public requireTitle: boolean;
    public collectGender: boolean;
    public requireGender: boolean;
    public collectBirthDate: boolean;
    public requireBirthDate: boolean;
    public collectBirthPlace: boolean;
    public requireBirthPlace: boolean;
    public collectEducationLevel: boolean;
    public requireEducationLevel: boolean;
}


// WEBPACK FOOTER //
// ./src/models/DemographicOptionsViewModel.tsx